import { useState, useEffect, useReducer } from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";

import { SET_IS_LOADING as SET_IS_LOADING_ACTION } from "Redux/actionTypes";

import {
  getAndSetDealDetails,
  updateSelectedDealDetail
} from "Redux/actions/dealDetailsAction";
import { setHelpLeadBucket } from "Redux/actions/getHelpAction";
import { checkFeatures } from "Redux/actions/commonAction";

import {
  Container,
  useRouter,
} from "components/atoms/DependencyHelper";
import DealDetailsHeader from "components/molecules/dealDetailsHeader/DealDetailsHeader";
import DealDetailsBody from "components/organisms/dealDetailsBody/DealDetailsBody";
import DealDetailsFooterTop from "components/organisms/dealDetailFooterTop/DealDetailFooterTop";
import DealDetailsFooterBottom from "components/organisms/dealDetailFooterBottom/DealDetailFooterBottom";
import ClickAndCollectModal from "components/molecules/modals/clickAndCollectModal/ClickAndCollectModal";
import PageError from "components/molecules/pageError/pageError";
import ErrorTooltip from "components/molecules/errorToolTip/ErrorTooltip";
// import ajaxServices from "../../../utils/ajaxServices";
// import { urlResolver } from "../../../config/queries";
import Seo from 'components/atoms/Seo/Seo';

import VasContext from "context/VasContext";

import {
  link as AnalyticsLink,
  getUtagData as AnalyticsGetUtagData,
  setAutoTagging as AnalyticsSetAutoTagging,
  getProfileData as AnalyticsGetProfileData,
  view as AnalyticsView
} from "services/analyticsUtag";

import {
  dynamicBreadCrumb,
} from "utils/helperServices";
import handleGeoLocation, {
  getNearestStore,
} from "utils/handleGeoLocation";

import config from "../../../config";
import labels from "../../../config/labels";
import types from "../../../config/types";
import { LEAD_BUCKETS } from "../../../config/constants";

const k8sConfig = typeof window === "undefined" ? require("config") : "";

const DealDetailsPage = (props) => {
  const [analytics, setAnalytics] = useState(false);

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const shoppingUrlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const router = useRouter();

  const [showError, setShowError] = useState(false);
  const [status, setStatus] = useState();
  const [isModalOpen, setShowModal] = useState(false);
  const [storeAddress, populateStoreList] = useState([]);
  const [nearestStore, setNearestStore] = useState("");
  const [serviceDown, setServiceDown] = useState(true);
  const [isClickAndCollectEligible, setIsClickAndCollectEligible] = useState(true);

  const [vasList, setVasList] = useReducer(reducer, []);
  const [vasAvailable, setVasAvailable] = useState(false);
  const [dealSKU, setDealSKU] = useState();
  const [lowCompLaod, setLowCompLaod] = useState(true);
  const [contractSKUS, setContractSKUS] = useState(null);
  const [seoDetails, setSeoDetails] = useState(null);

  const vasProviderValue = {
    vasAvailable,
    setVasAvailable,
    dealSKU,
    setDealSKU,
    vasList,
    setVasList,
  };
  const [showSnackBar, setShowSnackBar] = useState({
    visible: false,
    message: "",
  });

  useEffect(() => {
    props?.setHelpLeadBucket(LEAD_BUCKETS.general);
    props.checkFeatures();

    if (showError) {
      AnalyticsLink({
        page_name: "shopping: deal details",
        page_form_event: "error",
        page_errors: `${labels.lbl_menu_top.lbl_deal_404_heading}. ${labels.lbl_menu_top.lbl_deal_404_description}`,
        page_errors_code: `ddp-m-p-dd-${status}`,
      });
    }
  }, []);

  const getUserLocation = (productSKU) => {
    handleGeoLocation(props, productSKU, populateStoreList, setServiceDown);
  };

  useEffect(() => {
    if (storeAddress && storeAddress.length) {
      const storeDetails = getNearestStore(storeAddress);
      setNearestStore(storeDetails);
    }
  }, [storeAddress]);

  const selectedStoreDetails = (selectedStore) => {
    if (selectedStore) {
      setNearestStore(selectedStore);
    }
    hideCndCModal();
  };

  useEffect(() => {
    if (props.features?.clickAndCollectEnabled) {
      if (props.activeContract
        && props.activeContract?.enable_click_and_collect
        && props?.activeContractValue?.promotion_tag_label != types.TYPE_PREORDER
      ) {
        getUserLocation(props.activeContract?.primary_product_sku);
        setIsClickAndCollectEligible(true);
      } else {
        setIsClickAndCollectEligible(false);
      }
    }
  }, [props.activeContract]);

  const dispatch = useDispatch();
  const setLoadingState = (isLoading) => dispatch({
    type: SET_IS_LOADING_ACTION,
    payload: isLoading
  });

  const handleSeoData = (data = {}) => {
    const tempSeo = {};

    if (data?.meta_title) tempSeo.metaTitle = data.meta_title;
    if (data?.meta_description) tempSeo.metaDescription = data.meta_description;

    if(Object.keys(tempSeo).length) setSeoDetails(tempSeo);
  }

  async function fetchData() {
    setLoadingState(true);
    setLowCompLaod(true);

    const sku = props.query?.id?.toLowerCase?.();

    setContractSKUS(props.query.id);

    // const urlResolverData = await ajaxServices.fetchGraphQLPOSTRequest(
    //   urlResolver,
    //   { url: props.query.id }
    // );

    // const { route } = urlResolverData || {};
    // const { redirect_code, relative_url } = route || {};

    // if (relative_url && redirect_code > 0) {

    //   return router.push(addObjectKeysToUrl(relative_url, props.query));
    // }

    const result = await props.getAndSetDealDetails(sku);

    handleSeoData(result?.productItem);

    setStatus(result?.status);
    setShowError(result.isError);

    if (!result.ok) {
      AnalyticsLink({
        page_name: "shopping: deal details",
        page_form_event: "error",
        page_errors: `${labels.lbl_menu_top.lbl_deal_404_heading}. ${labels.lbl_menu_top.lbl_deal_404_description}`,
        page_errors_code: `ddp-m-p-dd-${result?.status}`,
      });
    }

    if (result && result.errors) {
      AnalyticsLink({
        page_name: "shopping: deal details",
        page_form_event: "error",
        page_errors: `${
          result.errors?.[0] ? result.errors?.[0]?.message : ""
        }`,
        page_errors_code: `ddp-m-p-dd-${result?.status}`,
      });
    }

    setLoadingState(false);
    setLowCompLaod(false);

  }

  useEffect(() => {
    if (props?.query) {
      fetchData();
      return;
    }
  }, [props?.query]);

  const handleActiveContract = (id) => {
    props.updateSelectedDealDetail(id);

    let contracts = contractSKUS;

    if (!Array.isArray(contractSKUS)) {
      contracts = [`${contractSKUS}`];
    } else {
      const total = contractSKUS.length;
      const contractPosition = contractSKUS.indexOf(id);

      if (contractPosition !== -1 && contractPosition !== total - 1) {
        const filteredContracts = contractSKUS.filter(
          (contract) => contract !== id
        );

        filteredContracts.push(id);
        contracts = filteredContracts;
      }
    }

    if (contracts) {
      contracts.map((contract) => {
        if (contract.id === id) {
          AnalyticsLink({
            ...AnalyticsGetUtagData([
              "page_name",
              "page_channel",
              "page_master_tab",
              "sales_product_id",
              "sales_product_price",
              "sales_product_quantity",
              "sales_order_discount",
              "sales_promo_name",
              "page_site_section_lvl_1",
              "page_site_section_lvl_2",
              "page_site_section_lvl_3",
            ]),
            page_tool_event: "use",
            page_tool_name: "shopping: deal details: contract duration filter",
            filter_query: `${contract.duration} months`,
            sales_product_price: [props.activeContract?.payment_terms],
            sales_order_discount: [props.activeContract?.save_monthly_recurring],
          });
        }
      });
    }
  };

  const isSim = !props.activeContract?.installment;

  const dynamicRoute = dynamicBreadCrumb();

  useEffect(() => {
    AnalyticsSetAutoTagging(false);

    if (Object.keys(dynamicRoute).length && props.activeContract) {
      const userMetaData = AnalyticsGetProfileData(
        props.userLoggedIn,
        props.profileData
      );
      const breadcrumbs = Object.keys(dynamicRoute).reverse();
      const section_lvls = {};
      let index = 0;

      for (let item of breadcrumbs) {
        index = index + 1;
        if (index > 4) break;
        section_lvls[`page_site_section_lvl_${index}`] = item;
      }

      if (!analytics) {
        const analyticsData = {
          page_event: "view",
          page_name: "shopping: deal details",
          page_channel: "shopping",
          page_master_tab: "personal",
          sales_event: "view",
          sales_product_id: [props.activeContract?.sku],
          sales_product_price: [props.activeContract?.payment_terms],
          sales_product_quantity: [1],
          sales_order_discount: [props.activeContract?.save_monthly_recurring],
          sales_promo_name: [props.activeContract?.promotion_tag_label],
          ...userMetaData,
          ...section_lvls,
        };

        if (props.activeContract?.promotion_tag_label) {
          analyticsData.sales_promo_name = [
            props.activeContract?.promotion_tag_label,
          ];
        }

        if (props?.activeContractValue?.promotion_tag_label == types.TYPE_PREORDER) {
          analyticsData.preorder_flag = "true";
        }

        if (props.activeContract?.stock_status?.toLowerCase() === "out_of_stock") {
          analyticsData.page_tool_event = "use";
          analyticsData.page_tool_name =
            "shopping: devices: Deal details: out of stock";
        }

        analyticsData.out_of_stock = props.activeContract?.stock_status?.toLowerCase();
        AnalyticsView(analyticsData);
        setAnalytics(true);
      }
    }
  }, [dynamicRoute, props.activeContract]);

  const goToDeals = () => {
    AnalyticsLink({
      page_name: "shopping: deal details",
      link_type: "o",
      link_name: "shopping: deal details: error Browse all deals",
    });
    setLoadingState(true);

    router.push(`${shoppingUrlPrefix}/deals`).then(() => {
      setLoadingState(false);
    });
  };

  function reducer(state, item) {
    if (item.length !== 0) {
      if (item.action === "add") {
        return [...state, item];
      }

      const updatedVasList = state.filter((vasItem) => vasItem.id !== item?.id);

      return updatedVasList;
    }

    return [];
  }

  const showModal = () => {
    setShowModal(true);
  };

  const hideCndCModal = () => {
    setShowModal(false);
  };

  const isVasloaded = (isLoaded) => {
    setVasAvailable(isLoaded);
  };

  const displaySnakbar = () => {
    setShowSnackBar({
      visible: true,
      message: labels.errorMessages.lbl_back_order_deal_unavailable,
    });
  };

  const closeSnackBar = () => {
    setShowSnackBar({
      visible: false,
      message: "",
    });
  };

  return (
    <>
      {seoDetails && <Seo
          metaTitle={seoDetails.metaTitle}
          title={seoDetails.metaTitle}
          content={seoDetails.metaDescription}
        />}

      {showError ? (
        <PageError
          className="not-found"
          heading={labels.lbl_menu_top.lbl_deal_404_heading}
          description={labels.lbl_menu_top.lbl_deal_404_description}
          primaryLabel="Browse all deals"
          handlePrimaryClick={goToDeals}
          imgUrl={`${imagePrefix}/assets/images/search-not-found.svg`}
        />
      ) : (
        <VasContext.Provider value={vasProviderValue}>
          {showSnackBar?.visible && (
            <ErrorTooltip
              errorMsg={showSnackBar?.message}
              buttonHandler={closeSnackBar}
              setFixedTop={props.isMiniApp}
            />
          )}

          { props.activeContract && (
            <Container className="deal-detail-page">
              <ClickAndCollectModal
                sku={props.activeContract.primary_product_sku}
                isModalOpen={isModalOpen}
                hideModal={hideCndCModal}
                storeAddress={storeAddress}
                geoLocationIsAllowed={props.geoLocation?.allowed}
                selectedStore={selectedStoreDetails}
              />

              {vasList.length !== 0 && (
                <DealDetailsHeader productName="Deal details & add-ons" />
              )}

              {vasList.length === 0 && (
                <DealDetailsHeader productName="Deal details" />
              )}

              <DealDetailsBody
                handleContract={(id) => handleActiveContract(id)}
                urlQuery={props?.query}
                isDealDetailPage={true}
                dealCategoryId={props?.dealCategoryId}
                onShowModalStores={showModal}
                lowCompLaod={lowCompLaod}
                geoLocationIsAllowed={props.geoLocation?.allowed}
                nearestStore={nearestStore}
                isStoreStockServiceDown={serviceDown}
                isVasloaded={isVasloaded}
                isCandCEligible={isClickAndCollectEligible}
                backOderDealUnavailable={displaySnakbar}
              />

              <DealDetailsFooterTop isSim={isSim} />
              { (props.similarDeals?.length > 0 || props.relatedDeals?.length > 0 ) && <DealDetailsFooterBottom /> }
            </Container>
          )}
        </VasContext.Provider>
      )}
    </>
  );
};

// function addObjectKeysToUrl(baseString, obj) {
//   const searchParams = new URLSearchParams();

//   for (const [key, value] of Object.entries(obj)) {
//     if(['id', 'contractSkus'].includes(key)) {
//       continue
//     }
//     searchParams.append(key, value);
//   }
//   const queryString = searchParams.toString();

//   const connector = baseString.includes('?') ? '&' : '?';

//   return queryString ? `${baseString}${connector}${queryString}` : baseString;
// }


export const getServerSideProps = async ({ query }) => {
  let categoryId = k8sConfig ? k8sConfig.get("category.dealcategoryid") : "";

  return {
    props: {
      query,
      dealCategoryId: categoryId,
    },
  };
};

DealDetailsPage.propTypes = {
  activeContractValue: PropTypes.object,
  similarDeals: PropTypes.any,
  relatedDeals: PropTypes.any,
  contracts: PropTypes.any,
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
  showError: PropTypes.bool,
  status: PropTypes.any,
  setHelpLeadBucket: PropTypes.func,
  backOderDealUnavailable: PropTypes.func,
  dealCategoryId: PropTypes.string,
  isMiniApp: PropTypes.bool,
  geoLocation: PropTypes.object,
  query: PropTypes.shape({
    contractSkus: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]),
    id: PropTypes.string,
  }),

  // Redux
  activeContract: PropTypes.object,
  checkFeatures: PropTypes.func,
  dealList: PropTypes.arrayOf(PropTypes.object),
  features: PropTypes.object,
  getAndSetDealDetails: PropTypes.func,
  primaryProduct: PropTypes.object,
  updateSelectedDealDetail: PropTypes.func,
};

const mapStateToProps = (state) => ({
  activeContract: state.dealDetails.selectedDealDetails,
  features: state.common.features,
  dealList: state.dealDetails.dealList,
  similarDeals: state.dealDetails.similarDeals,
  relatedDeals: state.dealDetails.relatedDeals,
  geoLocation: state.geoLocation,
  isMiniApp: state.navDetails.isMiniApp,
  primaryProduct: state.dealDetails.primaryProduct,
  profileData: state.navDetails.profileData,
  userLoggedIn: state.navDetails.isUserLoggedIn,
});

const mapDispatchToProps = {
  setHelpLeadBucket,
  getAndSetDealDetails,
  updateSelectedDealDetail,
  checkFeatures
}

export default connect(mapStateToProps, mapDispatchToProps)(DealDetailsPage);
